import { useStore } from 'effector-react'
import * as React from 'react'
import {
  $balanceSummary,
  $passiveBalances,
  getBalanceSummary,
  balanceSummaryMounted,
} from './model'

export const useBalanceSummary = () => {
  React.useEffect(() => {
    balanceSummaryMounted()
  }, [])

  const balanceSummary = useStore($balanceSummary)
  const passiveBalances = useStore($passiveBalances)
  const loading = useStore(getBalanceSummary.pending)

  return { balanceSummary, passiveBalances, loading }
}
